module.exports = __webpack_public_path__ + "media/Components/fonts/lato-0b51cf32bbc2d8b8d840c80c77a84a31.ttf";